import { render, staticRenderFns } from "./lnk-pagination-v.vue?vue&type=template&id=1abbe194&"
import script from "./lnk-pagination-v.vue?vue&type=script&lang=js&"
export * from "./lnk-pagination-v.vue?vue&type=script&lang=js&"
import style0 from "./lnk-pagination-v.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports